// export const appUrl = "https://Pharma-system.com/pharma/acc-api/public/";
// export const appUrl = "http://127.0.0.1:8000/";

export const client_Id = "2";
export const client_Secret = "swTnbbN9XfQg3ancY8hTAfUr38cE0nbvUuQjHKUA";
export const apiMethods = {
  login: "api/login",
  login_client: "api/login_client",
  check_auth: "api/check_auth",
  get_permissions: "api/get_permissions",
  logout: "api/logout",
  log_me: "api/log_me",
  see_notify: "api/see_notify",
  see_sms: "api/see_sms",
  notification_sms: "api/notification_sms",
  logs_not_seen: "api/logs_not_seen",
  logs_not_sent: "api/logs_not_sent",
  sms_not_seen: "api/sms_not_seen",
  orders_and_fatwora_page: "api/orders_and_fatwora_page",
  client_users: "api/client_users",
  add_client_user: "api/add_client_user",
  update_client_user: "api/update_client_user",
  delete_client_user: "api/delete_client_user",
  jobs: "api/jobs",
  add_job: "api/add_job",
  update_job: "api/update_job",
  delete_job: "api/delete_job",
  client_classes: "api/client_classes",
  add_client_class: "api/add_client_class",
  update_client_class: "api/update_client_class",
  delete_client_class: "api/delete_client_class",
  item_price_layeres: "api/item_price_layeres",
  add_item_price_layer: "api/add_item_price_layer",
  update_item_price_layer: "api/update_item_price_layer",
  delete_item_price_layer: "api/delete_item_price_layer",
  offer_items: "api/offer_items",
  add_offer_item: "api/add_offer_item",
  update_offer_item: "api/update_offer_item",
  delete_offer_item: "api/delete_offer_item",
  regions: "api/regions",
  add_region: "api/add_region",
  update_region: "api/update_region",
  delete_region: "api/delete_region",
  moneys: "api/moneys",
  add_money: "api/add_money",
  update_money: "api/update_money",
  delete_money: "api/delete_money",
  money_fatworas: "api/money_fatworas",
  employers: "api/employers",
  mandobs: "api/mandobs",
  employers_page: "api/employers_page",
  employers_salary: "api/employers_salary",
  add_employer: "api/add_employer",
  update_employer: "api/update_employer",
  delete_employer: "api/delete_employer",
  branches: "api/branches",
  add_branch: "api/add_branch",
  update_branch: "api/update_branch",
  delete_branch: "api/delete_branch",
  mohafzas: "api/mohafzas",
  cities: "api/cities",
  client_types: "api/client_types",
  users: "api/users",
  user: "api/user",
  add_user: "api/add_user",
  reset_user_password: "api/reset_user_password",
  update_user: "api/update_user",
  delete_user: "api/delete_user",
  cheques: "api/cheques",
  clients: "api/clients",
  clients_page: "api/clients_page",
  client: "api/client",
  upload_client_file: "api/upload_client_file",
  add_client: "api/add_client",
  update_client: "api/update_client",
  delete_client: "api/delete_client",
  importers: "api/importers",
  importer: "api/importer",
  add_importer: "api/add_importer",
  update_importer: "api/update_importer",
  delete_importer: "api/delete_importer",
  stores: "api/stores",
  all_stores: "api/all_stores",
  stores_of: "api/stores_of",
  store: "api/store",
  add_store: "api/add_store",
  update_store: "api/update_store",
  delete_store: "api/delete_store",
  groups: "api/groups",
  group: "api/group",
  add_group: "api/add_group",
  update_group: "api/update_group",
  delete_group: "api/delete_group",
  employer_hafezs: "api/employer_hafezs",
  add_employer_hafez: "api/add_employer_hafez",
  update_employer_hafez: "api/update_employer_hafez",
  delete_employer_hafez: "api/delete_employer_hafez",
  employer_khasms: "api/employer_khasms",
  add_employer_khasm: "api/add_employer_khasm",
  update_employer_khasm: "api/update_employer_khasm",
  delete_employer_khasm: "api/delete_employer_khasm",
  employer_badalats: "api/employer_badalats",
  add_employer_badalat: "api/add_employer_badalat",
  update_employer_badalat: "api/update_employer_badalat",
  delete_employer_badalat: "api/delete_employer_badalat",
  employer_solfas: "api/employer_solfas",
  add_employer_solfa: "api/add_employer_solfa",
  update_employer_solfa: "api/update_employer_solfa",
  delete_employer_solfa: "api/delete_employer_solfa",
  items: "api/items",
  items_of: "api/items_of",
  items_of_specific_order: "api/items_of_specific_order",
  item: "api/item",
  add_item: "api/add_item",
  update_item: "api/update_item",
  delete_item: "api/delete_item",
  khazinas: "api/khazinas",
  khazina: "api/khazina",
  khazina_transfer_fatworas: "api/khazina_transfer_fatworas",
  add_khazina: "api/add_khazina",
  update_khazina: "api/update_khazina",
  delete_khazina: "api/delete_khazina",
  khazina_client_sadads: "api/khazina_client_sadads",
  khazina_importer_sadads: "api/khazina_importer_sadads",
  khazina_deposit_all: "api/khazina_deposit_all",
  khazina_withdrew_all: "api/khazina_withdrew_all",
  banks: "api/banks",
  bank: "api/bank",
  add_bank: "api/add_bank",
  update_bank: "api/update_bank",
  delete_bank: "api/delete_bank",
  ohdas: "api/ohdas",
  add_ohda: "api/add_ohda",
  add_tasfia: "api/add_tasfia",
  update_ohda: "api/update_ohda",
  delete_ohda: "api/delete_ohda",
  sadadtypes: "api/sadadtypes",
  sadadtype: "api/sadadtype",
  add_sadadtype: "api/add_sadadtype",
  update_sadadtype: "api/update_sadadtype",
  delete_sadadtype: "api/delete_sadadtype",
  importer_fatworas: "api/importer_fatworas",
  importer_fatwora: "api/importer_fatwora",
  add_importer_fatwora: "api/add_importer_fatwora",
  update_importer_fatwora: "api/update_importer_fatwora",
  delete_importer_fatwora: "api/delete_importer_fatwora",
  madionia_importer: "api/madionia_importer",
  madionia_client: "api/madionia_client",
  search_importer_by_code: "api/search_importer_by_code",
  search_client_by_code: "api/search_client_by_code",
  search_fatwora_import_by_code: "api/search_fatwora_import_by_code",
  search_fatwora_client_by_code: "api/search_fatwora_client_by_code",
  fatworas: "api/fatworas",
  fatwora_detail: "api/fatwora_detail",
  fatwora_reback_detail: "api/fatwora_reback_detail",
  tanfiz_fatworas: "api/tanfiz_fatworas",
  tanfiz_confirm: "api/tanfiz_confirm",
  taslim_fatworas: "api/taslim_fatworas",
  taslim_confirm: "api/taslim_confirm",
  taslim_reject: "api/taslim_reject",
  solmt_fatworas: "api/solmt_fatworas",
  solmt_confirm: "api/solmt_confirm",
  solmt_reject: "api/solmt_reject",
  sarf_from_store_fatworas: "api/sarf_from_store_fatworas",
  sarf_from_store_confirm: "api/sarf_from_store_confirm",
  sarf_from_store_reject: "api/sarf_from_store_reject",
  fatwora: "api/fatwora",
  add_fatwora: "api/add_fatwora",
  accept_fatwora: "api/accept_fatwora",
  update_fatwora: "api/update_fatwora",
  delete_fatwora: "api/delete_fatwora",
  delete_fatwora_client_before_store: "api/delete_fatwora_client_before_store",
  orders: "api/orders",
  add_order: "api/add_order",
  confirm_order: "api/confirm_order",
  reject_order: "api/reject_order",
  sadadstatuses: "api/sadadstatuses",
  sadadstatus: "api/sadadstatus",
  add_sadadstatus: "api/add_sadadstatus",
  update_sadadstatus: "api/update_sadadstatus",
  delete_sadadstatus: "api/delete_sadadstatus",
  importer_fatwora_rebacks: "api/importer_fatwora_rebacks",
  importer_fatwora_reback: "api/importer_fatwora_reback",
  add_importer_fatwora_reback: "api/add_importer_fatwora_reback",
  buy_fatwora: "api/buy_fatwora",
  delete_buy_fatwora: "api/delete_buy_fatwora",
  remove_item_from_import_fatwora: "api/remove_item_from_import_fatwora",
  confirm_fatwora_buy: "api/confirm_fatwora_buy",
  reject_fatwora_buy: "api/reject_fatwora_buy",
  all_reback_fatworas: "api/all_reback_fatworas",
  reback_fatworas: "api/reback_fatworas",
  confirm_reback_fatwora: "api/confirm_reback_fatwora",
  client_fatwora_rebacks: "api/client_fatwora_rebacks",
  client_fatwora_reback: "api/client_fatwora_reback",
  add_client_fatwora_reback: "api/add_client_fatwora_reback",
  fatworas_transfer_from: "api/fatworas_transfer_from",
  fatworas_transfer_to: "api/fatworas_transfer_to",
  add_fatwora_transfer: "api/add_fatwora_transfer",
  update_fatwora_transfer: "api/update_fatwora_transfer",
  transfer_confirm: "api/transfer_confirm",
  transfer_reject: "api/transfer_reject",
  all_transfer_fatworas: "api/all_transfer_fatworas",
  fatworas_client_no_sadad: "api/fatworas_client_no_sadad",
  fatworas_importer_no_sadad: "api/fatworas_importer_no_sadad",
  khazna_fatworas: "api/khazna_fatworas",
  add_client_sadad: "api/add_client_sadad",
  add_importer_sadad: "api/add_importer_sadad",
  delete_importer_sadad: "api/delete_importer_sadad",
  add_client_khasm: "api/add_client_khasm",
  delete_client_khasm: "api/delete_client_khasm",
  delete_client_sadad: "api/delete_client_sadad",
  add_khasm_madionia: "api/add_khasm_madionia",
  add_deposit: "api/add_deposit",
  add_withdrew: "api/add_withdrew",
  add_khazinaTransfer: "api/add_khazinaTransfer",
  add_masrof: "api/add_masrof",
  card_sanf: "api/card_sanf",
  gardStore: "api/gardStore",
  add_employer_store: "api/add_employer_store",
  delete_employer_store: "api/delete_employer_store",
  employer_stores: "api/employer_stores",
  add_start_item_quantity: "api/add_start_item_quantity",
  delete_start_item_quantity: "api/delete_start_item_quantity",
  store_items_start: "api/store_items_start",
  bank_fatworas: "api/bank_fatworas",
  add_bank_deposit: "api/add_bank_deposit",
  add_bank_withdrew: "api/add_bank_withdrew",
  add_BankTransfer: "api/add_BankTransfer",
  clienttypes: "api/clienttypes",
  add_omola: "api/add_omola",
  add_hafez: "api/add_hafez",
  add_khasm: "api/add_khasm",
  add_badalat: "api/add_badalat",
  add_solfa: "api/add_solfa",
  employers_vacation: "api/employers_vacation",
  add_agaza: "api/add_agaza",
  add_absence: "api/add_absence",
  ClientDetailAccount: "api/ClientDetailAccount",
  ClientAccount: "api/ClientAccount",
  employers_attends: "api/employers_attends",
  add_come: "api/add_come",
  add_go: "api/add_go",
  change_password: "api/change_password",
  FinalFatworas: "api/FinalFatworas",
  get_all_client_info: "api/get_all_client_info",
  get_all_info_of_importer: "api/get_all_info_of_importer",
  delete_transfer_fatwora: "api/delete_transfer_fatwora",
  delete_deposit_khazna: "api/delete_deposit_khazna",
  delete_masrof: "api/delete_masrof",
  add_cheque: "api/add_cheque",
  update_cheque: "api/update_cheque",
  delete_cheque: "api/delete_cheque",
  mandob_targets: "api/mandob_targets",
  add_mandob_targets: "api/add_mandob_targets",
  update_mandob_targets: "api/update_mandob_targets",
  delete_mandob_targets: "api/delete_mandob_targets",
  remove_item_from_target: "api/remove_item_from_target",
  confirm_order_from_super: "api/confirm_order_from_super",
  update_order_from_super: "api/update_order_from_super",
  delete_order_from_super: "api/delete_order_from_super",
  tax_fatworas: "api/tax_fatworas",
  add_tax_fatwora: "api/add_tax_fatwora",
  delete_tax_fatwora: "api/delete_tax_fatwora",

  new_clients: "api/new_clients",
  confirm_new_client: "api/confirm_new_client",
  mandobVisits: "api/mandobVisits",
  mandobTasks: "api/mandobTasks",
  addTask: "api/addTask",
  delete_task: "api/deleteTask",
  tahsilat: "api/tahsilat",
  confirm_tahsilat: "api/confirm_tahsilat",
  tracks: "api/tracks",
  users_chat: "api/users_chat",
  get_chat: "api/get_chat",
  add_new_message: "api/add_new_message",
  user_behavior: "api/user_behavior",

  Attendreport: "api/Attendreport",
  MandobClientMadioniaReport: "api/MandobClientMadioniaReport",
  MandobClientTypeReport: "api/MandobClientTypeReport",
  MandobItemReport: "api/MandobItemReport",
  MandobSalesReport: "api/MandobSalesReport",
  TahsilatReport: "api/TahsilatReport",
  ClientsWithBranch: "api/ClientsWithBranch",
  ClientsWithMandob: "api/ClientsWithMandob",
  ClientsWithNew: "api/ClientsWithNew",
  ClientsWithRegion: "api/ClientsWithRegion",
  TasksReport: "api/TasksReport",
  mandob_target: "api/mandob_target",
  BranchSalesReport: "api/BranchSalesReport",
  BranchSalesReportAllDetail: "api/BranchSalesReportAllDetail",
  BranchMadioniaReport: "api/BranchMadioniaReport",
  CompanyMadioniaReport: "api/CompanyMadioniaReport",
  CompanySalesReport: "api/CompanySalesReport",
  ItemSalesReport: "api/ItemSalesReport",
  ItemBuyReport: "api/ItemBuyReport",
  ItemClientTypeReport: "api/ItemClientTypeReport",
  AllVisitsSuper: "api/AllVisitsSuper",
  MandobClientSadadReport: "api/MandobClientSadadReport",
  StoreItemTransferReport: "api/StoreItemTransferReport",
  StoreOneItemTransferReport: "api/StoreOneItemTransferReport",
  StoreGardDetailReport: "api/StoreGardDetailReport",
  ClientSadadReport: "api/ClientSadadReport",
  KhazinaInputReport: "api/KhazinaInputReport",
  KhazinaInputDetailReport: "api/KhazinaInputDetailReport",
  KhazinaImporterSadadReport: "api/KhazinaImporterSadadReport",
  EmployerSalaryReport: "api/EmployerSalaryReport",
  EmployerOmolaReport: "api/EmployerOmolaReport",
  RebackClientReport: "api/RebackClientReport",
  RebackMandobReport: "api/RebackMandobReport",
  RebackItemReport: "api/RebackItemReport",
  RebackItemBuyReport: "api/RebackItemBuyReport",
  RebackImporterReport: "api/RebackImporterReport",
  MasrofAllReport: "api/MasrofAllReport",
  MasrofWithTypeReport: "api/MasrofWithTypeReport",
  RebackSellAll: "api/RebackSellAll",
  RebackSellAllByFatwora: "api/RebackSellAllByFatwora",
  RebackBuyAll: "api/RebackBuyAll",
  StoreMovementReport: "api/StoreMovementReport",
  StoreMovementAllReport: "api/StoreMovementAllReport",
  ItemSalesAverageReport: "api/ItemSalesAverageReport",
  ClientSalesValueReport: "api/ClientSalesValueReport",
  ClientSadadSalesAverageReport: "api/ClientSadadSalesAverageReport",


  ImporterAccount: "api/ImporterAccount",
  solmt_fatworas_mandob: "api/solmt_fatworas_mandob",
  recent_orders_mandob: "api/recent_orders_mandob",
  getloactions: "api/getloactions",
  profit: "api/profit",
  profit_items: "api/profit_items",
  makhzon_cost: "api/makhzon_cost",
  delete_tahsil: "api/delete_tahsil",
  delete_reback_fatwora: "api/delete_reback_fatwora",
  click_event: "api/clickevent"
};
